var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppFlowTransition',[(_vm.page)?_c('div',{key:_vm.$route.params.step},[_c(_vm.page.Component,{tag:"component",attrs:{"page":_vm.page}})],1):_vm._e()]),_c('AppNav',{attrs:{"fields":_vm.fields,"hasError":_vm.errors,"page":_vm.page}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }